import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getUserNewsletter} from 'src/openapi/admin/apis/GetUserNewsletterApi';
import {userNewsletterUpdate} from 'src/openapi/admin/apis/UserNewsletterUpdateApi';
import {useAppDispatch} from 'src/store/hooks';

import type {SaveOptions} from 'src/components/save-with-reason/save-with-reason-button';

export const useUserNewsletter = ({userId}: {userId: number}) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getUserNewsletter({userId}),
    ), [userId, apiDispatch]);

    const saveDispatchAction = useCallback((
        newsletterType: string[],
        signal: AbortSignal,
        options?: SaveOptions,
    ) => apiDispatch(
        userNewsletterUpdate({
            userId,
            userNewsletterUpdateRequest: {newsletterTypeCodes: newsletterType, reason: options?.reason},
        }, {signal}),
    ), [userId, apiDispatch]);

    return useCommonDataHook({
        getDispatchAction,
        saveDispatchAction,
        initValue: [],
    });
};
